import React from 'react';
import MediaQuery from 'react-responsive';
import { mobileNavigationPageWidthThreshold, mobilePageWidthThreshold } from 'src/core/constants/mobilePages';

export const DesktopWidthView: React.FC<{ isNavigation?: boolean }> = ({ children, isNavigation }) => (
  <MediaQuery minWidth={isNavigation ? mobileNavigationPageWidthThreshold : mobilePageWidthThreshold + 1 + 'px'}>
    {children}
  </MediaQuery>
);
